import { Tab } from "./tab.interface";

export const createFragment = (tab: Tab) => tab.title.toLowerCase().replace(/\s+/g, "-");

export const findTabToNavigateTo = (
  urlFragment: string,
  currentTab: Tab,
  allTabs: Tab[]
): Tab | undefined => {
  if (createFragment(currentTab) === urlFragment) {
    return;
  }

  return findTabByUrlFragment(urlFragment, allTabs);
};

const findTabByUrlFragment = (aFragment: string, tabs: Tab[]) =>
  tabs.find((tab) => createFragment(tab) === aFragment.replace(/^#/, ""));
